import { isAuthorized } from 'utils/Auth'

import { setFilterValue } from 'reduxpath/ducks/Product/List'

import { createReducer } from '../utils'

export const CITY_BY_COUNTRY_ID_REQUEST = 'getcraft/reference/CITY_BY_COUNTRY_ID_REQUEST'
export const CITY_BY_COUNTRY_ID_SUCCESS = 'getcraft/reference/CITY_BY_COUNTRY_ID_SUCCESS'
export const CITY_BY_COUNTRY_ID_ERROR = 'getcraft/reference/CITY_BY_COUNTRY_ID_ERROR'

export const COUNTRY_REQUEST = 'sherrinford/reference/COUNTRY_REQUEST'
export const COUNTRY_SUCCESS = 'sherrinford/reference/COUNTRY_SUCCESS'
export const COUNTRY_ERROR = 'sherrinford/reference/COUNTRY_ERROR'

export const SERVICE_REQUEST = 'sherrinford/reference/SERVICE_REQUEST'
export const SERVICE_SUCCESS = 'sherrinford/reference/SERVICE_SUCCESS'
export const SERVICE_ERROR = 'sherrinford/reference/SERVICE_ERROR'

export const SELECTIONS_CITY = 'getcraft/reference/SELECTIONS_CITY'
export const SELECTIONS_COUNTRY = 'sherrinford/reference/SELECTIONS_COUNTRY'
export const SELECTIONS_SERVICE = 'sherrinford/reference/SELECTIONS_SERVICE'

export const SELECTED_CITY = 'getcraft/reference/SELECTED_CITY'
export const SELECTED_COUNTRY = 'sherrinford/reference/SELECTED_COUNTRY'
export const SELECTED_SERVICE = 'sherrinford/reference/SELECTED_SERVICE'

export const SELECTED_PROJECT_STATUS = 'sherrinford/reference/SELECTED_PROJECT_STATUS'

export const SELECTED_CLEAN = 'sherrinford/reference/SELECTED_CLEAN'

export const IS_LOADING = 'sherrinford/reference/IS_LOADING'

export const GET_PRODUCT_TYPE_REQUEST = 'sherrinford/reference/GET_PRODUCT_TYPE_REQUEST'
export const GET_PRODUCT_TYPE_SUCCESS = 'sherrinford/reference/GET_PRODUCT_TYPE_SUCCESS'
export const GET_PRODUCT_TYPE_FAILED = 'sherrinford/reference/GET_PRODUCT_TYPE_FAILED'

export const GET_FORMAT_REQUEST = 'sherrinford/reference/GET_FORMAT_REQUEST'
export const GET_FORMAT_SUCCESS = 'sherrinford/reference/GET_FORMAT_SUCCESS'
export const GET_FORMAT_FAILED = 'sherrinford/reference/GET_FORMAT_FAILED'

export const SELECT_FILTER_TYPE = 'sherrinford/reference/SELECT_FILTER_TYPE'

export const SELECT_FILTER_SERVICE = 'sherrinford/reference/SELECT_FILTER_SERVICE'

export const SELECT_FILTER_FORMAT = 'sherrinford/reference/SELECT_FILTER_FORMAT'

export const RESET_SELECTION = 'sherrinford/reference/RESET_SELECTION'

export const GET_SUBSCRIPTION_PLAN_REQUEST =
  'sherrinford/reference/GET_SUBSCRIPTION_PLAN_REQUEST'
export const GET_SUBSCRIPTION_PLAN_SUCCESS =
  'sherrinford/reference/GET_SUBSCRIPTION_PLAN_SUCCESS'
export const GET_SUBSCRIPTION_PLAN_FAILED =
  'sherrinford/reference/GET_SUBSCRIPTION_PLAN_FAILED'

const fileImage = 'image'
const fileVideo = 'video'
const fileText = 'text'
const initialState = {
  countries: {
    count: 0,
    totalPages: 1,
    currentPage: 1,
    rows: [],
  },
  services: {
    count: 0,
    totalPages: 1,
    currentPage: 1,
    rows: [],
  },
  selectionsCountry: [
    {
      label: '',
      value: '',
    },
  ],
  selectionsCity: [
    {
      label: '',
      value: '',
    },
  ],
  selectionsService: [{}],
  selectionsProductType: [],

  selectedCountry: '',
  selectedCity: '',
  selectedService: '',

  selectedProjectStatus: '',

  productTypeSlug: {
    create: 'create',
    sponsor: 'sponsor',
  },

  poStatus: {
    pending: {
      label: 'Pending Review',
      value: 0,
    },
    approved: {
      label: 'Approved',
      value: 1,
    },
    rejected: {
      label: 'Rejected',
      value: 2,
    },
  },

  statusDefinition: {
    order: [
      'Project Created',
      'Pitch Completed / Quotation Generated',
      'Quotation Approved By Client / PO Needed By Client',
      'PO Approved / Invoice Generated',
      'Project Running',
      'Project Complete',
      'Project Cancelled',
      'Project Expired',
      'Payment Needed',
    ],
    pitch: ['Pitch Submitted', 'Pitch Rejected', 'Pitch Approved'],
    po: ['Need Review', 'Approved', 'Rejected'],
    task: ['Not Started', 'In Progress', 'Completed'],
    statusOrder: {
      projectCreated: {
        status: 0,
      },
      quotationGenerated: {
        status: 1,
      },
      quotationApproved: {
        status: 2,
      },
      poApproved: {
        status: 3,
      },
      projectRunning: {
        status: 4,
      },
      projectCompleted: {
        status: 5,
      },
      projectCancelled: {
        status: 6,
      },
      projectExpired: {
        status: 7,
      },
      projectNeedPayment: {
        status: 8,
      },
    },
  },

  statusPitch: {
    selected: {
      status: 2,
      label: 'Selected',
    },
    onReview: {
      status: 0,
      label: 'On Review',
    },
    rejected: {
      status: 1,
      label: 'Rejected',
    },
    withdrawn: {
      status: 3,
      label: 'Withdrawn',
    },
  },

  financeStatus: {
    pending: {
      label: 'Waiting for verification',
      value: 0,
    },
    approved: {
      label: 'Verified',
      value: 1,
    },
    rejected: {
      label: 'Updates needed',
      value: 2,
    },
  },

  rejectReason: [
    {
      label: 'Invalid Company Legal Address',
      value: 0,
    },
    {
      label: 'Invalid Company Legal Name',
      value: 1,
    },
    {
      label: 'Incorrect Company TAX ID File',
      value: 2,
    },
  ],

  fileImage,
  fileVideo,
  fileText,
  mediaTypes: {
    'image/jpeg': fileImage,
    'image/png': fileImage,
    'image/tiff': fileImage,
    'video/avi': fileVideo,
    'video/quicktime': fileVideo,
    'video/mpeg': fileVideo,
    'video/mp4': fileVideo,
    'application/pdf': fileText,
  },

  isLoading: false,
  isError: false,
  errorMessage: '',
  invoiceStatus: {
    invoiceGenerated: {
      status: 0,
      label: 'Invoice Generated',
    },
    waitingConfirmation: {
      status: 1,
      label: 'Waiting Confirmation',
    },
    confirmed: {
      status: 2,
      label: 'Invoice Confirmed',
    },
    rejected: {
      status: 3,
      label: 'Invoice Rejected',
    },
  },

  productTypes: [],

  format: [],

  masterData: {
    productType: {},
    service: {},
    format: {},
  },

  paymentPercentage: {
    halfPayment: 50,
    fullPayment: 100,
  },

  subscriptionPlan: '',
}

export default createReducer(initialState, {
  [CITY_BY_COUNTRY_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [CITY_BY_COUNTRY_ID_SUCCESS]: (state, data) => ({
    ...state,
    cities: data,
    isLoading: false,
  }),
  [CITY_BY_COUNTRY_ID_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [COUNTRY_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [COUNTRY_SUCCESS]: (state, data) => ({
    ...state,
    countries: data,
    isLoading: false,
  }),
  [COUNTRY_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [SERVICE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [SERVICE_SUCCESS]: (state, data) => ({
    ...state,
    services: {
      ...state.services,
      count: data.count,
      currentPage: data.currentPage,
      totalPages: data.totalPages,
    },
    masterData: {
      ...state.masterData,
      service: data.rows,
    },
    isLoading: false,
  }),
  [SERVICE_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [GET_PRODUCT_TYPE_REQUEST]: state => ({
    ...state,
  }),
  [GET_PRODUCT_TYPE_SUCCESS]: (state, data) => ({
    ...state,
    productTypes: data.rows,
    masterData: {
      ...state.masterData,
      productType: data.rows,
    },
  }),
  [GET_PRODUCT_TYPE_FAILED]: state => ({
    ...state,
  }),

  [GET_FORMAT_REQUEST]: state => ({
    ...state,
  }),
  [GET_FORMAT_SUCCESS]: (state, data) => {
    const formatData = data.rows.map(format => ({
      label: format.name,
      value: format.id,
    }))
    return {
      ...state,
      format: formatData,
      masterData: {
        ...state.masterData,
        format: data.rows,
      },
    }
  },
  [GET_FORMAT_FAILED]: state => ({
    ...state,
  }),

  [SELECTIONS_CITY]: (state, data) => ({
    ...state,
    selectionsCity: data,
  }),
  [SELECTIONS_COUNTRY]: (state, data) => ({
    ...state,
    selectionsCountry: data,
  }),
  [SELECTIONS_SERVICE]: (state, data) => ({
    ...state,
    selectionsService: data,
  }),

  [SELECTED_CITY]: (state, data) => ({
    ...state,
    selectedCity: data,
  }),
  [SELECTED_COUNTRY]: (state, data) => ({
    ...state,
    selectedCountry: data,
  }),
  [SELECTED_SERVICE]: (state, data) => ({
    ...state,
    selectedService: data,
  }),

  [SELECTED_PROJECT_STATUS]: (state, data) => ({
    ...state,
    selectedProjectStatus: data,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [SELECTED_CLEAN]: (state, data) => ({
    ...state,
    selectedCountry: data.selectedCountry,
    selectedService: data.selectedService,
  }),

  [SELECT_FILTER_TYPE]: (state, data) => ({
    ...state,
    selectionsService: data.selectionsService,
    format: data.selectionsFormat,
  }),

  [SELECT_FILTER_SERVICE]: (state, data) => ({
    ...state,
    format: data.selectionsFormat,
    productTypes: data.filteredType,
  }),

  [SELECT_FILTER_FORMAT]: (state, data) => ({
    ...state,
    productTypes: data.filteredType,
    selectionsService: data.selectionsService,
  }),

  [RESET_SELECTION]: (state, data) => ({
    ...state,
    productTypes: data.productType,
    format: data.format,
    selectionsService: data.selectionsService,
  }),

  [GET_SUBSCRIPTION_PLAN_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_SUBSCRIPTION_PLAN_SUCCESS]: (state, data) => ({
    ...state,
    subscriptionPlan: data,
    isLoading: false,
  }),
  [GET_SUBSCRIPTION_PLAN_FAILED]: state => ({
    ...state,
    isError: true,
    isLoading: false,
  }),
})

/** Getters */
export function getCitiesByCountryId(id, pages = null, cb = () => {}) {
  const token = JSON.parse(isAuthorized())
  let qs = {
    limit: 99999,
    search: JSON.stringify({ country: id }),
  }
  if (pages) {
    qs = {
      search: JSON.stringify({ country: id }),
      ...pages,
    }
  }
  return {
    type: [
      CITY_BY_COUNTRY_ID_REQUEST,
      CITY_BY_COUNTRY_ID_SUCCESS,
      CITY_BY_COUNTRY_ID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/city',
      qs,
      authorization: token,
    },
    nextAction: res => cb(res),
  }
}

export function getCountries(cb = () => {}, searchParam = { is_active: true }) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [COUNTRY_REQUEST, COUNTRY_SUCCESS, COUNTRY_ERROR],
    shuttle: {
      method: 'GET',
      path: '/country',
      qs: {
        limit: 500,
        search: JSON.stringify(searchParam),
      },
      authorization: token,
    },
    nextAction: res => cb(res),
  }
}

export function getServices(cb = () => {}) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [SERVICE_REQUEST, SERVICE_SUCCESS, SERVICE_ERROR],
    shuttle: {
      method: 'GET',
      path: '/service',
      authorization: token,
    },
    nextAction: res => cb(res),
  }
}

export function getProductTypes() {
  const token = JSON.parse(isAuthorized())
  return {
    type: [GET_PRODUCT_TYPE_REQUEST, GET_PRODUCT_TYPE_SUCCESS, GET_PRODUCT_TYPE_FAILED],
    shuttle: {
      method: 'GET',
      path: '/product_type',
      authorization: `${token}`,
    },
  }
}

export function getFormat() {
  const token = JSON.parse(isAuthorized())
  return {
    type: [GET_FORMAT_REQUEST, GET_FORMAT_SUCCESS, GET_FORMAT_FAILED],
    shuttle: {
      method: 'GET',
      path: '/format',
      authorization: token,
      qs: {
        limit: 100,
      },
    },
  }
}

/** Selection Setters */
export function setSelectionsCity(data) {
  const countryArr = data.map(val => ({
    value: val.id,
    label: val.name,
  }))
  return {
    type: [SELECTIONS_CITY],
    payload: countryArr,
  }
}

export function setSelectionsCountry(data) {
  const countryArr = data.map(val => ({
    value: val.id,
    label: val.name,
  }))
  return {
    type: [SELECTIONS_COUNTRY],
    payload: countryArr,
  }
}

export function setSelectionsService(data) {
  const selectionsService = data.map(service => ({
    label: service.name,
    value: service.id,
  }))
  return {
    type: [SELECTIONS_SERVICE],
    payload: selectionsService,
  }
}

/** Selected Setters */
export function setSelectedCity(data) {
  return {
    type: [SELECTED_CITY],
    payload: data,
  }
}
export function setSelectedCountry(data) {
  return {
    type: [SELECTED_COUNTRY],
    payload: data,
  }
}
export function setSelectedService(data) {
  return {
    type: [SELECTED_SERVICE],
    payload: data,
  }
}

export function setSelectedProjectStatus(data) {
  return {
    type: [SELECTED_PROJECT_STATUS],
    payload: data,
  }
}

/** Misc */
export function setIsLoading(data) {
  return {
    type: [IS_LOADING],
    payload: data,
  }
}

export function setSelectedClean(data = initialState) {
  return {
    type: [SELECTED_CLEAN],
    payload: {
      selectedCountry: data.selectedCountry,
      selectedService: data.selectedService,
    },
  }
}

export function getMediaType(file) {
  try {
    return initialState.mediaTypes[file.type]
  } catch (e) {
    return false
  }
}

export function selectFilterType(data) {
  return (dispatch, getState) => {
    let filteredService = []
    let filteredFormat = []
    if (data !== '') {
      filteredService = getState().Reference.masterData.service.filter(
        service => service.productType.id === data
      )

      filteredService.forEach(service => {
        getState().Reference.masterData.format.forEach(format => {
          if (service.id === format.service.id) {
            filteredFormat.push(format)
          }
        })
      })
    } else {
      filteredService = getState().Reference.masterData.service
      filteredFormat = getState().Reference.masterData.format
    }

    const selectionsService = filteredService.map(service => ({
      label: service.name,
      value: service.id,
    }))

    const selectionsFormat = filteredFormat.map(format => ({
      label: format.name,
      value: format.id,
    }))

    const dataToStore = {
      selectionsService,
      selectionsFormat,
    }
    dispatch({
      type: [SELECT_FILTER_TYPE],
      payload: dataToStore,
    })
  }
}

export function selectFilterService(data) {
  return (dispatch, getState) => {
    let filteredType = []
    let filteredFormat = []
    if (data !== '') {
      getState().Reference.masterData.service.forEach(service => {
        if (service.id === data) {
          filteredType.push(service.productType)
        }
      })

      filteredFormat = getState().Reference.masterData.format.filter(
        format => format.service.id === data
      )

      const currentFilter = getState().ProductList.filter
      currentFilter.productType = filteredType[0].id
      dispatch(setFilterValue(currentFilter))
    } else {
      filteredType = getState().Reference.masterData.productType
      filteredFormat = getState().Reference.masterData.format
    }

    const selectionsFormat = filteredFormat.map(format => ({
      label: format.name,
      value: format.id,
    }))

    const dataToStore = {
      selectionsFormat,
      filteredType,
    }

    dispatch({
      type: [SELECT_FILTER_SERVICE],
      payload: dataToStore,
    })
  }
}

export function selectFilterFormat(data) {
  return (dispatch, getState) => {
    let filteredType = []
    let filteredService = []
    if (data !== '') {
      getState().Reference.masterData.format.forEach(format => {
        if (format.id === data) {
          filteredService.push(format.service)
        }
      })

      getState().Reference.masterData.service.forEach(service => {
        if (service.id === filteredService[0].id) {
          filteredType.push(service.productType)
        }
      })

      const currentFilter = getState().ProductList.filter
      currentFilter.productType = filteredType[0].id
      currentFilter.service = filteredService[0].id
      dispatch(setFilterValue(currentFilter))
    } else {
      filteredType = getState().Reference.masterData.productType
      filteredService = getState().Reference.masterData.service
    }

    const selectionsService = filteredService.map(service => ({
      label: service.name,
      value: service.id,
    }))

    const dataToStore = {
      selectionsService,
      filteredType,
    }

    dispatch({
      type: [SELECT_FILTER_FORMAT],
      payload: dataToStore,
    })
  }
}

export function resetSelection() {
  return (dispatch, getState) => {
    const productType = getState().Reference.masterData.productType

    const selectionsService = getState().Reference.masterData.service.map(service => ({
      label: service.name,
      value: service.id,
    }))

    const format = getState().Reference.masterData.format.map(formatData => ({
      label: formatData.name,
      value: formatData.id,
    }))

    const data = {
      productType,
      selectionsService,
      format,
    }

    dispatch({
      type: [RESET_SELECTION],
      payload: data,
    })
  }
}

export function getSubsciptionPlan(cb = () => {}) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_SUBSCRIPTION_PLAN_REQUEST,
      GET_SUBSCRIPTION_PLAN_SUCCESS,
      GET_SUBSCRIPTION_PLAN_FAILED,
    ],
    shuttle: {
      method: 'GET',
      path: '/subscription_plan',
      authorization: token,
    },
    nextAction: res => cb(res),
  }
}
